import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { Link } from 'react-router-dom';
import DeleteDiscountFormModal from 'src/features/discounts/components/forms/DeleteDiscountFormModal';
import { Discount } from 'src/features/discounts/utils/types';
import UpdateDiscountFormModal from 'src/features/discounts/components/forms/UpdateDiscountFormModal';
import { discountsMessages } from 'src/features/discounts/utils/messages';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

type CellDiscountActions = {
    row: Row<Discount>;
};

export default function CellDiscountActions({ row }: CellDiscountActions) {
    const { formatMessage } = useIntl();

    const isDiscountUsed = row.original.is_used;
    const permissionManageDiscounts = useHasPermissions([PERMISSION.MANAGE_DISCOUNTS]);

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/discounts/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>
                {permissionManageDiscounts && !isDiscountUsed && (
                    <>
                        <Tooltip>
                            <UpdateDiscountFormModal
                                semantics={{ entryName: formatMessage(discountsMessages.discount).toLowerCase() }}
                                selectedDiscount={row.original}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                    </Button>
                                </TooltipTrigger>
                            </UpdateDiscountFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.edit} />
                            </TooltipContent>
                        </Tooltip>
                        <Tooltip>
                            <DeleteDiscountFormModal selectedDiscount={row.original}>
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                    </Button>
                                </TooltipTrigger>
                            </DeleteDiscountFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.delete} />
                            </TooltipContent>
                        </Tooltip>
                    </>
                )}
            </TooltipProvider>
        </div>
    );
}
